// extracted by mini-css-extract-plugin
module.exports = {"Container":"RestaurantDetail_Container__3X6V7","Separator":"RestaurantDetail_Separator__38qIh"};